export default class utils {
    static getExt(name) {
        const index = name.lastIndexOf('.')
        if (index === -1 || index === name.length - 1) return ''
        return name.substr(index + 1).toLowerCase()
    }

    static getFileName(name) {
        const index = name.lastIndexOf('.') || name.length - 1
        if (index === -1 || index === name.length - 1) return name
        return name.substr(0, index)
    }

    static isImage(name) {
        const exts = [
            'png',
            'jpg',
            'jpeg',
            'gif',
            'bmp',
            'ico',
            'webp',
            'heic',
            'pic',
        ]
        const ext = this.getExt(name)
        return exts.find((i) => i === ext) ? true : false
    }

    static isEditor(contentType = '') {
        return contentType === 'DOCUMENT'
    }

    static isVideo(name) {
        const exts = ['mp4', 'rmvb', 'mkv', 'avi', 'mov']
        const ext = this.getExt(name)
        return exts.find((i) => i === ext) ? true : false
    }

    static isAudio(name) {
        const exts = ['wav', 'aif', 'au', 'mp3', 'm4a']
        const ext = this.getExt(name)
        return exts.find((i) => i === ext) ? true : false
    }

    static isZip(name) {
        const exts = ['zip', 'tar', '7z', 'jar', 'rar', 'gzip', 'gz']
        const ext = this.getExt(name)
        return exts.find((i) => i === ext) ? true : false
    }

    static isWps(name) {
        const exts = [
            'doc',
            'dot',
            'wps',
            'wpt',
            'docx',
            'dotx',
            'docm',
            'dotm',
            'xls',
            'xlt',
            'et',
            'xlsx',
            'xltx',
            'xlsm',
            'xltm',
            'ppt',
            'pptx',
            'pptm',
            'ppsx',
            'ppsm',
            'pps',
            'potx',
            'potm',
            'dpt',
            'dps',
            'pdf',
            'mht',
            'mhtml',
            'html',
            'htm',
            'rtf',
            'uot3',
            'md',
            'zip',
            'tar',
            '7z',
            'jar',
            'rar',
            'gzip',
            'gz',
            'txt',
        ]
        const ext = this.getExt(name)
        return exts.find((i) => i === ext) ? true : false
    }

    static isTDWps(name, contentType) {
        const exts = [
            'docx',
            'doc',
            'dot',
            'dotx',
            'docm',
            'dotm',
            'xlsx',
            'xls',
            'csv',
            'xlt',
            'xltx',
            'xlsm',
            'xltm',
            'pptx',
            'ppt',
            'pptm',
            'ppsx',
            'ppsm',
            'pps',
            'potx',
            'potm',
            'pdf',
            'ofd',
            // 企微支持的格式
            'txt',
            'c',
            'cpp',
            'bat',
            'xml',
            'json',
            'md',
            'ini',
            'kml',
            'lua',
            // 企微暂时不支持的格式
            // 'java',
            // 'js',
            // 'css',
            // 'cmake',
            // 'asm',
            // 's',
            // 'asp',
            // 'bash',
            // 'go',
            // 'sql',
            // 'html',
            // 'ts',
            // 'wps',
            // 'wpt',
            // 'et',
            // 'dpt',
            // 'dps',
            // 'mht',
            // 'mhtml',
            // 'htm',
            // 'rtf',
            // 'uot3'
        ]
        const tdContentTypes = ['BOARD', 'SMART_SHEET', 'FLOW_CHART', 'MIND']
        const ext = this.getExt(name)
        return exts.includes(ext) || tdContentTypes.includes(contentType)
    }

    static isExceedMaxLimit(size) {
        const maxSize = 1024 * 1024 * 1024 * 100; // 100GB
        return size > maxSize;
    }

    static isWpsPreview(name) {
        // const exts = [
        //     'mht',
        //     'mhtml',
        //     'html',
        //     'htm',
        //     'rtf',
        //     'uot3',
        //     'md',
        //     'zip',
        //     'tar',
        //     '7z',
        //     'jar',
        //     'rar',
        //     'gzip',
        //     'gz',
        //     'txt',
        // ]
        const exts = [
            'docx',
            'doc',
            'dot',
            'dotx',
            'docm',
            'dotm',
            'xlsx',
            'xls',
            'csv',
            'xlt',
            'xltx',
            'xlsm',
            'xltm',
            'pptx',
            'ppt',
            'pptm',
            'ppsx',
            'ppsm',
            'pps',
            'potx',
            'potm',
            'pdf',
        ];
        const ext = this.getExt(name)
        return exts.find((i) => i === ext) ? false : true
    }

    static isPcMode() {
        const agent = navigator.userAgent.toLowerCase()
        if (agent.match(/microMessenger/i) === 'micromessenger') return false
        if (/android|webos|iphone|ipod|balckberry/i.test(agent)) return false
        return true
    }

    static isInToca() {
        return navigator.userAgent.toLowerCase().indexOf('toca') !== -1
    }
}
